<template>
  <div class="p-4">
    <!-- Barre de recherche -->
    <div class="relative mb-4">
      <input 
        type="text" 
        v-model="searchQuery" 
        placeholder="Rechercher un utilisateur..." 
        class="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:border-blue-300"
      />
      <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
        <i class="fas fa-search"></i>
      </span>
      <span 
        v-if="searchQuery.trim().length" 
        class="cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
        @click="searchQuery = ''"
      >
        <i class="fas fa-times"></i>
      </span>
    </div>

    <div class="flex flex-col gap-4">
      <div v-for="user in filteredUsers" :key="user.id" class="basicInput flex items-start !h-fit"
        @click.stop="goToUserDetails(user)"
      >
        <div class="flex items-center justify-between w-full">
          <div class="text-left">
            <p class="text-gray-600 font-bold select-none">{{ user.name }}</p>
            <p class="text-gray-600 select-none">{{ user.email }}</p>
          </div>
          <div class="flex gap-4">
            <button class="callToAction w-9">▶</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchUsers } from '@/services/userService';

export default {
  data() {
    return {
      users: [],
      searchQuery: "",
    };
  },
  computed: {
    filteredUsers() {
      let result = this.users;
      // Filtre par recherche (full name)
      if (this.searchQuery.trim()) {
        const search = this.searchQuery.toLowerCase();
        result = result.filter(res =>
          (`${res.email || ''} ${res.name || ''}`).toLowerCase().includes(search)
        );
      }

      return result;
    },
  },
  methods: {
    goToUserDetails(user) {
      this.$router.push({ name: 'user-details', params: { id: user.id } });
    }
  },
  async mounted(){
    this.users = await fetchUsers();
  }
}
</script>